/**
 * Error model for `@qrvey/query-builder`.
 *
 * Every failure is a {@link QueryBuilderError} with a stable {@link
 * QueryBuilderErrorCode} and a `path` pointing at the offending input location
 * (e.g. `$.groupBy[0].limit`). Add a code here when a new failure mode appears.
 */

export type QueryBuilderErrorCode =
    | 'INVALID_INPUT'
    | 'MISSING_ENGINE'
    | 'UNSUPPORTED_ENGINE'
    | 'UNSUPPORTED_ENGINE_BEHAVIOR'
    | 'INVALID_IDENTIFIER'
    | 'INVALID_FIELD_TYPE'
    | 'INVALID_OPERATOR_FOR_TYPE'
    | 'INVALID_IN_VALUE'
    | 'INVALID_GROUP_SELECTION'
    | 'INVALID_AGGREGATION_SELECTION'
    | 'INVALID_HAVING_CONDITION'
    | 'INVALID_ORDER_BY'
    | 'INVALID_MUTATION'
    | 'UNFILTERED_MUTATION'
    | 'UNSUPPORTED_AGGREGATION_FOR_ENGINE'
    | 'UNSUPPORTED_DATE_GRANULARITY_FOR_ENGINE'
    | 'UNSUPPORTED_PAGINATION_FOR_ENGINE'
    | 'UNSUPPORTED_GROUP_LIMIT_FOR_ENGINE'
    | 'LIMIT_EXCEEDED'
    | 'SKIP_EXCEEDED'
    | 'MAX_SELECTED_FIELDS_EXCEEDED'
    | 'SEARCH_AFTER_REQUIRES_ORDER_BY'
    | 'AMBIGUOUS_PAGINATION';

export type QueryBuilderErrorPayload = {
    code: QueryBuilderErrorCode;
    /** JSON-path-like pointer to the offending input, e.g. `$.select[0]`. */
    path: string;
    message: string;
    details?: Record<string, unknown>;
};

export class QueryBuilderError extends Error {
    readonly code: QueryBuilderErrorCode;
    readonly path: string;
    readonly details?: Record<string, unknown>;

    constructor(readonly payload: QueryBuilderErrorPayload) {
        super(payload.message);
        this.name = 'QueryBuilderError';
        this.code = payload.code;
        this.path = payload.path;
        this.details = payload.details;
    }
}
